<template>
  <div v-show="alertSocket" class="alert">
    <icon class="alert__icon"/>
    <div class="alert__warning">
      {{ $t("offline.message") }}
    </div>
    <div class="alert__description">
      {{ $t("offline.reconnect") }}
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Icon from '@/assets/icons/no-wifi.svg';

export default {
  components: {
    Icon,
  },
  computed: {
    ...mapState({
      alertSocket: (state) => state.alertSocket,
    }),
  },
  created() {
    window.addEventListener('online', () => {
      this.setAlertSocket(false);
    });

    window.addEventListener('offline', () => {
      this.setAlertSocket(true);
    });
  },
  destroyed() {
    window.removeEventListener('online', null);
    window.removeEventListener('offline', null);
  },
  methods: {
    ...mapMutations([
      'setAlertSocket',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/components/alert-socket.scss";
</style>
